import { useAppSelector } from '../../../app/hooks';
import { Buffer } from 'buffer';
import {
  convertCrosspolAdjustmentFromDBForForm,
  getAdjustedCrossPolData,
} from '../../crosspol/utils/conversionsAndCalculations';
import { selectTraceDataBySnapshotId } from '../../spectrasWebSocketServer/spectrasWebSocketServerSlice';

import { useSnapshot } from 'features/snapshots/api/getSnapshot';

const useCrossPolData = (crossPolSnapshotId: number | undefined | null) => {
  const { data: crosspolSnapshot } = useSnapshot({
    snapshotId: crossPolSnapshotId || -1,
  });
  let crossPolSnapshotData = useAppSelector((state) =>
    selectTraceDataBySnapshotId(state, crossPolSnapshotId)
  );

  if (!crossPolSnapshotData || crossPolSnapshotData.length === 0) return [];

  // Pull from last_trace to populate crosspol data on initial load
  if (
    (!crossPolSnapshotData || crossPolSnapshotData.length === 0) &&
    crosspolSnapshot?.last_trace
  ) {
    crossPolSnapshotData = Buffer.from(crosspolSnapshot?.last_trace)
      .toString('utf8')
      .split(',')
      .map(Number);
  }

  const finalCrossPolAdjustment =
    crosspolSnapshot?.crosspol_adjustment === undefined
      ? '0'
      : convertCrosspolAdjustmentFromDBForForm(
          crosspolSnapshot?.crosspol_adjustment
        );

  return getAdjustedCrossPolData(crossPolSnapshotData, finalCrossPolAdjustment);
};

export default useCrossPolData;
